import { StakeholderType, UserType } from "./EnumsInternal";

function userLogIn(result: {}) {
    localStorage.setItem('x-access-user', JSON.stringify(result));
}

function userLogOut(setLoginUser: Function) {
    localStorage.removeItem('x-access-user');
    setLoginUser(null);
}

function initUserObject(setLoginUser: Function) {
    var userJsonString = localStorage.getItem('x-access-user') ?? null;
    userJsonString !== null ? setLoginUser(JSON.parse(userJsonString)) : setLoginUser(null);
}

function checkUserToken(userLoginObject: any) {    
    if (userLoginObject.loginUser && userLoginObject.loginUser.refreshTokenExpiry &&
        Date.parse(userLoginObject.loginUser?.refreshTokenExpiry) <= Date.now()) {
        userLogOut(userLoginObject.setLoginUser);
    }
}

function isUserTypeAllowed(userType: UserType, requiredUserType: UserType) {
    return userType === UserType.Developer || userType <= requiredUserType;
}

function isStakeholderTypeAllowed(stakeholderType: StakeholderType, requiredStakeholderType: StakeholderType) {
    return stakeholderType === requiredStakeholderType;
}


export { userLogIn, userLogOut, initUserObject, checkUserToken, isUserTypeAllowed, isStakeholderTypeAllowed }
